import React from 'react';
import autoBind from 'react-autobind';
import AccountSettingsStore from '../../stores/AccountSettingsStore';
import AccountSettingsActions from '../../actions/AccountSettingsActions';
import SectionHeader from '../Common/SectionHeader.jsx';
import BankAccountDetails from '../Common/BankAccountDetails.jsx';
import ClassNames from 'classnames';

export default class AccountSettingsSection extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = this.getStateFromStore();
    }

    getStateFromStore(){
        return {
            data: AccountSettingsStore.getModel(),
            errorList: AccountSettingsStore.getFormError()
        };
    }

    componentDidMount() {
        AccountSettingsStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        AccountSettingsStore.removeChangeListener(this._onChange);
    }
		
    _onChange() {
		this.setState(this.getStateFromStore());
    }

    render() {
		return (
            <div className="form-step">
                <div className="form-sub-section">
                    <SectionHeader focus={this.props.focus} sectionName={this.props.content.accountSettings.sectionHeader} />
                    <div className="container">
                        {this.state.data.map((value, index) => (
                            <div key={`as_subSection${index}`} className={ClassNames({'sub-section': value.name.fullName})}>
                                {value.name.fullName ? <h4 key={`as_subHeader${index}`}>{value.name.fullName}</h4> : null}
                                <BankAccountDetails section="as"
                                                    index={index} 
                                                    data={value} 
                                                    errorList={this.state.errorList}
                                                    onBlur={this.updateAccountSettings.bind(this, index)}
                                                    key={`as_${index}`} />
                            </div>))}
                    </div>
                </div>
            </div>
        );
    }

    updateAccountSettings(index, event){
        AccountSettingsActions.updateAccountSettings(event.target.model, event.target.id, event.target.value, index);
    }
}



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/AccountSettings/AccountSettingsSection.jsx